import { WorkflowsItemContextMenuItemBase } from './workflows-context-menu-base';
import { WorkflowsComponent } from '../../../views/site/workflows/workflows.component';
import { TrashDeleteEvent } from '../../components/list-view/list-view-trash-config.model';

// Define menu classes.
export class OpenWorkflowItemContextMenuData extends WorkflowsItemContextMenuItemBase {
    public constructor(itemTitle: string, component: WorkflowsComponent) {
        super(itemTitle, component);
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        //this.component.doOnOpenItemClick(eventData);
        // Call the existing doOnEdit() method.
        let editParam = {
            'originalEvent': eventData,
            'item': this.contextItem//this.contextMenu.menuData.item
        };
        this.component.doOnEdit(editParam);
    }
}

export class DeleteWorkflowItemContextMenuData extends WorkflowsItemContextMenuItemBase {
    public constructor(itemTitle: string, component: WorkflowsComponent) {
        super(itemTitle, component);
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        //this.component.doOnDeleteItemClick(eventData);
        let doOnItemDeleteParam: TrashDeleteEvent =
            new TrashDeleteEvent(eventData, this.contextItem);//this.contextMenu.menuData.item);
        this.component.doOnItemDelete(doOnItemDeleteParam);
    }
}
